import { j as a } from "../../../jsx-runtime-B6kdoens.js";
import { c as m, f as s } from "../../../create-component-CBAeEoQ6.js";
import { Card as e } from "../index.js";
const c = m(
  "ProductCard",
  s(({ children: r, ...o }, t) => /* @__PURE__ */ a.jsx(e, { ref: t, ...o, children: r }))
);
export {
  c as ProductCard
};
//# sourceMappingURL=index.js.map
